import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function getStatusColor(status) {
  if (!status) return 'bg-gray-300 text-black';
  // Safety: ensure status is a string (SCMejora may return objects)
  const statusStr = typeof status === 'object' ? (status.nombre || status.codigo || '') : String(status);
  if (!statusStr) return 'bg-gray-300 text-black';
  
  // Mapeo directo para estados de SCMejora
  const directColorMapping = {
    'estados.rechazada_corto': 'bg-red-700 text-white',
    'estados.pendiente': 'bg-yellow-500 text-black',
    'estados.pendiente_entidad_corto': 'bg-yellow-500 text-black',
    'estados.en_ejecucion': 'bg-blue-600 text-white',
    'estados.reparacion.finalizada': 'bg-green-600 text-white',
    'estados.aceptada_corto': 'bg-green-500 text-white',
    'estados.pausada': 'bg-orange-500 text-black',
  };
  
  if (directColorMapping[statusStr]) {
    return directColorMapping[statusStr];
  }
  
  // Fallback a búsqueda por palabras clave
  const statusLower = statusStr.toLowerCase();
  
  if (statusLower.includes('finalizada') || statusLower.includes('completada') || statusLower.includes('resuelta') || statusLower.includes('cerrada')) {
    return 'bg-green-600 text-white';
  }
  if (statusLower.includes('ejecucion') || statusLower.includes('progreso') || statusLower.includes('reparacion') && !statusLower.includes('finalizada')) {
    return 'bg-orange-500 text-black';
  }
  if (statusLower.includes('pendiente')) {
    return 'bg-gray-400 text-black';
  }
  if (statusLower.includes('rechazada') || statusLower.includes('bloqueada')) {
    return 'bg-red-700 text-white';
  }
  if (statusLower.includes('abierta')) {
    return 'bg-red-500 text-white';
  }
  
  return 'bg-gray-300 text-black';
}

export function getStatusLabel(status) {
  if (!status) return 'Sin Estado';
  // Safety: ensure status is a string
  const statusStr = typeof status === 'object' ? (status.nombre || status.codigo || '') : String(status);
  if (!statusStr) return 'Sin Estado';
  
  // Mapeo directo para estados de SCMejora
  const directMapping = {
    'estados.rechazada_corto': 'Rechazada',
    'estados.pendiente': 'Pendiente',
    'estados.pendiente_entidad_corto': 'Pendiente',
    'estados.en_ejecucion': 'En Ejecución',
    'estados.reparacion.finalizada': 'Finalizada',
    'estados.aceptada_corto': 'Aceptada',
    'estados.pausada': 'Pausada',
  };
  
  if (directMapping[statusStr]) {
    return directMapping[statusStr];
  }
  
  // Fallback a búsqueda por palabras clave
  const statusLower = statusStr.toLowerCase();
  
  if (statusLower.includes('finalizada') || statusLower.includes('completada') || statusLower.includes('resuelta')) {
    return 'Completada';
  }
  if (statusLower.includes('ejecucion') || statusLower.includes('progreso')) {
    return 'En Progreso';
  }
  if (statusLower.includes('reparacion') && !statusLower.includes('finalizada')) {
    return 'En Reparación';
  }
  if (statusLower.includes('pendiente')) {
    return 'Pendiente';
  }
  if (statusLower.includes('rechazada')) {
    return 'Rechazada';
  }
  if (statusLower.includes('bloqueada')) {
    return 'Bloqueada';
  }
  if (statusLower.includes('abierta')) {
    return 'Abierta';
  }
  
  return status;
}

export function getPriorityColor(priority) {
  if (priority >= 4) return 'border-red-500 text-red-600';
  if (priority === 3) return 'border-orange-500 text-orange-600';
  return 'border-blue-300 text-blue-600';
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
